export const rpmReadings = {
  googleFit: [
    { dateTime: '2021-02-05T01:17:33.000Z', weight: 195.3 },
    { dateTime: '2021-02-05T01:43:33.000Z', weight: 197.5 },
    { dateTime: '2021-02-13T15:55:34.000Z', weight: 195.6 },
  ],
};
